import { render, staticRenderFns } from "./footerTpl.vue?vue&type=template&id=176105ce&"
import script from "./footerTpl.vue?vue&type=script&lang=js&"
export * from "./footerTpl.vue?vue&type=script&lang=js&"
import style0 from "./footerTpl.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports